import { ReactNode, useState } from 'react';
import { Button } from '@arkestro/arkestro-design-system';
import { InheritedBusinessUnitEditModal } from './inherited-business-unit-edit-modal';
import styles from './inherited-business-unit-field.module.scss';
import type { ID } from 'types';

interface InheritedBusinessUnitAgreementLinkProps {
  agreementId: ID;
  children?: ReactNode;
  linked: boolean;
}

/** The agreement's name in the caption: a link that offers to open the agreement when it can still be edited. */
export const InheritedBusinessUnitAgreementLink = ({ agreementId, children, linked }: InheritedBusinessUnitAgreementLinkProps) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  if (!linked) return <span>{children}</span>;

  return (
    <>
      <Button
        className={styles.agreementLink}
        data-testid='inherited-business-unit-agreement-link'
        onClick={() => setIsEditModalOpen(true)}
        type='link'
      >
        {children}
      </Button>
      <InheritedBusinessUnitEditModal
        agreementId={agreementId}
        onClose={() => setIsEditModalOpen(false)}
        open={isEditModalOpen}
      />
    </>
  );
};
